import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=fdda2f6c&scoped=true"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=fdda2f6c&prod&lang=scss"
import style1 from "./UserProfile.vue?vue&type=style&index=1&id=fdda2f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdda2f6c",
  null
  
)

export default component.exports